import { PromptType } from "../../types/market-recap";
import { PROMPT_TYPES } from "./promptConfigs";
import { cn } from "../../lib/utils";

interface PromptTypeStepProps {
  selectedType: PromptType | null;
  onSelect: (type: PromptType) => void;
}

export function PromptTypeStep({
  selectedType,
  onSelect,
}: PromptTypeStepProps) {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-xl font-semibold text-foreground">
          What would you like to recap?
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Select the type of market recap you want to create
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {PROMPT_TYPES.map((promptType) => {
          const Icon = promptType.icon;
          const isSelected = selectedType === promptType.id;

          return (
            <button
              key={promptType.id}
              onClick={() => onSelect(promptType.id)}
              className={cn(
                "group relative flex flex-col items-start gap-3 p-6 rounded-xl border-2 transition-all text-left",
                "hover:border-primary/50 hover:bg-primary/5",
                isSelected
                  ? "border-primary bg-primary/10 ring-2 ring-primary/20"
                  : "border-border bg-card"
              )}
            >
              {/* Icon */}
              <div
                className={cn(
                  "flex items-center justify-center w-12 h-12 rounded-xl transition-colors",
                  isSelected
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground group-hover:bg-primary/20 group-hover:text-primary"
                )}
              >
                <Icon className="h-6 w-6" />
              </div>

              {/* Content */}
              <div className="space-y-1">
                <h4
                  className={cn(
                    "font-semibold transition-colors",
                    isSelected ? "text-primary" : "text-foreground"
                  )}
                >
                  {promptType.name}
                </h4>
                <p className="text-sm text-muted-foreground">
                  {promptType.description}
                </p>
              </div>

              {/* Selected indicator */}
              {isSelected && (
                <div className="absolute top-3 right-3">
                  <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
                    <svg
                      className="w-4 h-4 text-primary-foreground"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
